import styled from 'styled-components';
import { SearchInput } from '../input';
import { ZTooltip } from '../ztooltip';

export const SidebarContainer = styled.div<{ position: string; $isMainSidebar?: boolean; $isDialog?: boolean }>`
    position: ${(props) => (props.$isDialog ? 'static' : props.position)};
    top: ${(props) => (props.$isDialog ? 'unset' : props.position === 'fixed' ? '68px' : '58px')};
    left: ${(props) => (props.$isDialog ? 'unset' : props.$isMainSidebar ? '0px' : '310px')};
    width: ${(props) => (props.$isDialog ? '100%' : '300px')};
    height: ${(props) => (props.$isDialog ? '100%' : `calc(100% - ${props.position === 'fixed' ? (props.$isMainSidebar ? '56px' : '85px') : '58px'})`)};
    background-color: white;
    padding: 20px 0px;
    overflow: auto;
`;

export const SidebarButtons = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    margin-left: auto;
`;

export const SidebarButtonStyle = styled.li`
    color: ${(props) => props.theme.app.primary};
    margin-left: 5px;
    height: 24px;
    width: 24px;
`;

export const TooltipCategories = styled(ZTooltip)`
    max-width: max-content;
`;

export const StyledSpan = styled.span<{ maxWidth?: string }>`
    max-width: ${(props) => props.maxWidth || 'max-content'};
`;

export const SidebarListItem = styled.div<{ $selected?: boolean; disabled?: boolean }>`
    display: flex;
    align-items: center;
    min-height: 48px;
    cursor: pointer;
    flex-wrap: wrap;

    /* 
	${SidebarButtons} {
		visibility: hidden;
	} */

    span {
        box-sizing: border-box;
        display: inline-block;
        /* width: 120px; */
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
    }

    /* &:hover {
		${SidebarButtons} {
			visibility: visible;
		}
	} */

    ${(props) =>
        !props.disabled &&
        `
    &:hover {
        opacity: 0.7;
    }`}

    ${(props) =>
        props.disabled &&
        `
    color: #BBB;
    `}

${(props) =>
        props.$selected &&
        `
    color: ${props.theme.app.secondary};
    font-weight: 600;
    `}
`;

export const SidebarHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    position: relative;
    min-height: 50px;

    &:after {
        content: '';
        border-bottom: 2px #e8edf0 solid;
        position: absolute;
        left: 20px;
        bottom: 0px;
        right: 20px;
        height: 1px;
    }
`;

export const SidebarHeader = styled.h1`
    margin: 0;
    flex: 1;
    font-size: 16px;
`;

export const SidebarSearchInput = styled(SearchInput)`
    padding: 5px;
    font-size: 10px;
    width: 100%;
    flex: 1;
    height: 30px;
`;
